import React from 'react';

const cardData = [
  {
    title: 'Chat with Customer',
    desc: 'Mas madali mo na makakausap ang Customer mo!',
    illustration: 'img/home1.png'
  },
  {
    title: 'Limited Time',
    desc: 'Pwede lang mag-chat habang active pa ang booking.',
    illustration: 'img/home2.png'
  },
  {
    title: 'Quick Tips!',
    desc: 'Siguraduhing malinaw kay customer ang iyong chat.',
    illustration: 'img/home3.png'
  }
];

export default class DaxDefaultView extends React.PureComponent {
  render() {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #0f2b3f 60%, #1a3a4f 100%)',
        color: '#fff',
        padding: '2rem 0',
        width: '100%',
        overflow: 'scroll',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginLeft: '2rem' }}>
          <div style={{ width: 56, height: 56, background: '#009FE3', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ fontSize: 32 }}>💬</span>
          </div>
          <h1 style={{ fontWeight: 700, fontSize: '2.5rem', margin: 0 }}>New: Welcome to Chat</h1>
        </div>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '2rem',
          justifyContent: 'center',
          height: '100%'
        }}>
          {cardData.map((card, idx) => (
            <div key={idx} style={{
              background: 'rgba(0, 0, 0, 0.25)',
              borderRadius: '2rem',
              padding: '2rem 1.5rem 0',
              minWidth: 280,
              maxWidth: 320,
              flex: '1 1 300px',
              color: '#c7d6e2',
              display: 'flex',
              flexDirection: 'column',
              gap: '2rem',
              alignItems: 'center',
              boxShadow: '0 4px 24px 0 rgba(0,0,0,0.10)',
              marginTop: 'auto',
              marginBottom: 'auto',
              height: 'fit-content',
            }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <text style={{ fontWeight: 700, fontSize: '1.5rem', color: '#fff', marginBottom: 8 }}>{card.title}</text>
                <text style={{ fontSize: '1.15rem', marginBottom: 24 }}>{card.desc}</text>
              </div>
              <div style={{ marginTop: 'auto', width: '100%' }}>
                <img src={card.illustration} alt={card.title} style={{ width: '100%', height: '100%', maxWidth: 300 }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
};
